import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
import { ApiProvider } from '../api/api';
import { Platform } from 'ionic-angular';
import moment from 'moment';
import md5 from 'md5';
import { AppState } from '../../config/state';


@Injectable()
export class LocationsProvider {
  public currentLocation: any;
  public closestBranch: any;
  private userLocation;

  constructor(private api: ApiProvider, private geo: Geolocation, private platform: Platform, private state : AppState) {
    // console.log(api, db, geo, platform)
    this.currentLocation = null;
    this.closestBranch = null;

    // this.getUserLocation();
  }

  findClosestBranch(locations, currentLoc) {
    let distances = [];

    locations.forEach(location => {
      let loc = { lat: location.locationLatitude, lng: location.locationLongitude };
      let distance = this.getDistance(currentLoc, loc);
      // Convert from meters to miles/feet
      distances.push({ d: distance, n: location.name, i: location.id });
    });

    if (distances.length > 0) {
      distances.sort((a, b) => {
        return a.d - b.d;
      })

      let miles = (distances[0].d / 1609.344).toFixed(2);
      let feet = (distances[0].d * 3.28).toFixed(2);

      let pack = {
        'id': distances[0].i,
        'name': distances[0].n,
        'miles': miles,
        'feet': feet,
        'meters': distances[0].d
      };

      this.closestBranch = pack;
      return pack;
    }
  }

  getDistance(currentPos, locationInfo) {
    var radlat1 = Math.PI * currentPos.lat / 180;
    var radlat2 = Math.PI * locationInfo.lat / 180;
    var theta = currentPos.lng - locationInfo.lng;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    return dist.toFixed(1);
  }


  getLocations(userId?:number): Promise<Array<Location>> {

    const query = `{
      allLocations(appVersion:2, includeHours: true ${userId ? ", userId: "+userId : ''}){
        id, clientId, pickupLocation, polarisId, appViewable, parentKeyword, locationLatitude, locationLongitude, name, keyword, hostPrefix, description, image, aboutUrl, phone, fax, email, fullAddress, line1, line2, line3, locality, zip, stateCounty, locationHours {
          start
          end
          day
          date
        }
      }
    }`;
    return this.api.getDataArray(query, 'id').then(res => {
      return res.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
      });
    });
  }

  getNearestLocations(lat, long): Promise<Array<Location>>{
    const query = `{
      allLocations(appVersion:2, includeHours:true, latitude:${lat}, longitude:${long}) {
        id, clientId, pickupLocation, polarisId, appViewable, parentKeyword, locationLatitude, locationLongitude, name, keyword, hostPrefix, description, image, aboutUrl, phone, fax, email, fullAddress, line1, line2, line3, locality, zip, stateCounty, distance, locationHours {
          start
          end
          day
          date
        }
      }
	}`
    return this.api.getDataArray(query, 'id', null, 60, md5(`${lat}-${long}`)).then(res => {
      if (!res) return this.getLocations();
      return res.sort((a, b) => {
        return a.distance - b.distance;
      });
    });
  }

  getLocation(locationId: Number): Promise<Location> {
    const query = `{
      getLocation(appVersion:2, id:${locationId}, includeHours:true){
        id, name, fax, parentKeyword, line1, line2, line3, image, email, phone, keyword, locality, zip, fullAddress, phone, locationLatitude, locationLongitude, locationHours {
          start
          end
          day
          date
        }
      }
    }`
    return this.api.getData(query, 'id', locationId, -1).then(location => {
      return location;
    })
  };

  async getRoomWeekHours(id: number, roomId: number, dateRequested: string, keepHourFormat?: boolean) {

  const query = `{
    getHoursForLocation(id: ${id}, roomId: ${roomId}, getHoursWeek:true, getHoursByDate: "${dateRequested}", appVersion: 2){
      start, end, day, exceptionReason, date
  }
}`;

  let weekHours = await this.api.query(query);
  if (!keepHourFormat) {
    weekHours.getHoursForLocation.map(day => {
      day.start = moment().hour(day.start.split(":")[0]).minute(day.start.split(":")[1]).format("h:mm a");
      day.end = moment().hour(day.end.split(":")[0]).minute(day.end.split(":")[1]).format("h:mm a");
      return day
    })
  }
  return weekHours.getHoursForLocation;
};

  async getWeekHours(id: number, dateRequested: string, keepHourFormat?: boolean) {//TODO: cache this maybe?
    const query = `{
        getHoursForLocation(id: ${id}, getHoursWeek:true, getHoursByDate: "${dateRequested}", appVersion: 2){
          start, end, day, exceptionReason, date
      }
    }`;

    let weekHours = await this.api.query(query);
    if (!keepHourFormat) {
      weekHours.getHoursForLocation.map(day => {
        day.start = moment().hour(day.start.split(":")[0]).minute(day.start.split(":")[1]).format("h:mm a");
        day.end = moment().hour(day.end.split(":")[0]).minute(day.end.split(":")[1]).format("h:mm a");
        return day
      })
    }
    return weekHours.getHoursForLocation;

  };

  getUserLocation():Promise<any> {
    console.log('location request is being called');
    return new Promise((resolve) => {
      if (this.userLocation) {
        return resolve(this.userLocation);
      } else {
        let coords: any = { lat: "", lng: "" };
        this.geo.getCurrentPosition({ maximumAge: 3000, timeout: 5000, enableHighAccuracy: true }).then((res) => {
          coords.lat = res.coords.latitude;
          coords.lng = res.coords.longitude;
          this.userLocation = coords;
          return resolve(coords);
        }, (error) => {
          return resolve(coords);
        }).catch((error) => {
          console.log("Error retrieving location: ", error.message);
          return resolve(coords);
        });
      }
    });
  }

  async emailBranchInfo(branch: Location, email){
    let image = encodeURIComponent(`http://${branch.parentKeyword}.libnet.info/images/locations/${branch.parentKeyword}/${branch.image}`);
    let description = encodeURIComponent(branch.description);
    let about = encodeURIComponent(branch.aboutUrl);
    let query = `{
      sendNotification(type:"branch_info", email:"${email}", phone: "", vars:{
      date: "${moment().format("MM/DD/YYYY hh:mm a")}",
      branch_name: "${branch.name}",
      full_address: "${(branch.fullAddress.replace(/(\r\n|\n|\r)/gm,' '))}",
      description: "${description}",
      longitude: "${branch.locationLongitude}",
      latitude: "${branch.locationLatitude}",
      image: "${image}",
      about_link: "${about}",
      phone: "${branch.phone}",
      email: "${branch.email}",
      fax: "${branch.fax}",
      street_one: "${branch.line1}",
      street_two: "${branch.line2}",
      street_three: "${branch.line3}",
      city: "${branch.locality}",
      state: "${branch.stateCounty}",
      zip: "${branch.zip}"
    }) {
        type
        status
        message
      }
    }`
    let notificationData = await this.api.query(query);
console.log(notificationData);
    return notificationData.sendNotification;
  }
}


export interface Location {
  id: number;
  clientId?: number;
  pickupLocation?: boolean;
  private?: boolean;
  appViewable?: number;
  locationLatitude?: number;
  locationLongitude?: number;
  parentKeyword?: string;
  name: string;
  keyword?: string;
  hostPrefix?: string;
  description?: string;
  image?: string;
  aboutUrl?: string;
  evancedName?: string;
  polarisName?: string;
  polarisCtx?: string;
  polarisId?: string;
  phone?: string;
  fax?: string;
  manager?: string;
  managerImage?: string;
  email?: string;
  fullAddress?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  locality?: string;
  zip?: string;
  stateCounty?: string;
  distance?: number;
  locationHours?: Array<Object>;
}


// WEBPACK FOOTER //
// ./src/providers/locations/locations.ts